





































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import TheTableDonations from '@/components/donations/TheTableDonations.vue';
import BasePagination from '@/base/BasePagination.vue';
// Importing function
import {getDonations} from '@/ts/donations/get-donations';

export default {
    name: 'PageDonations',
    components: {
        LayoutApp,
        BaseCard,
        TheTableDonations,
        BasePagination,
    },
    props: {},
    data() {
        return {
            items: Array(),
        };
    },
    methods: {
        // Switching between pages
        switchPage(page) {
            this.$store.dispatch('setLoadingOn');
            this.$store.dispatch('setCurrentPage', page);
            getDonations().then(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Дарения',
        }];
        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setOrderParam', '');
        this.$store.dispatch('setSortParam', '');
        this.$store.dispatch('setCurrentPage', 1);
        this.$store.dispatch('setLastPage', 1);
        // Fetching data from the API
        this.$store.dispatch('setLoadingOn');
        getDonations().finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
